import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import { BALANCE_PAGE_NAME } from '../../constants/service/app/balanceConstants';
import BalanceBrandListContainer from '../../containers/balance/BalanceBrandListContainer';

const BalanceBrandList = () => {
  return (
    <PageTemplate pageName={BALANCE_PAGE_NAME.BALANCE_BRAND_LIST}>
      <BalanceBrandListContainer />
    </PageTemplate>
  );
};

export default BalanceBrandList;
